import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useSelector } from "react-redux";
import { selectCandidateCv, selectIsFullCv } from "../../../modules/createJob/slice/candidateSlice";
import { Toolbar } from "./Toolbar";
import { Warning } from "../Warning/Warning";
import { useEffect, useMemo } from "react";
import { analytics } from "../../utils/analytics";
import { logEvent } from "firebase/analytics";
import './cvViewer.scss'
import "@cyntler/react-doc-viewer/dist/index.css";

export function CVViewer({ docViewerRef }: { docViewerRef: any }) {
    const candidateCv = useSelector(selectCandidateCv)
    const isFullCv = useSelector(selectIsFullCv);

    useEffect(() => {
        logEvent(analytics, 'Cv screen');
    }, [])

    const docs = [
        {
            uri: candidateCv,
            fileType: candidateCv.split('.').pop()
        }
    ];

    const config = useMemo(
        () => ({
        header: { overrideComponent: Toolbar },
        pdfZoom: {
            defaultZoom: isFullCv ? 0.8 : 1.1,
            zoomJump: 0.2,
        },
        pdfVerticalScrollByDefault: true,
        }),
        [isFullCv] 
    );

    return (
        <>
            {candidateCv ? (
                <DocViewer
                    key={`${isFullCv}-${candidateCv}`}
                    language="en"
                    ref={docViewerRef}
                    documents={docs}
                    pluginRenderers={DocViewerRenderers}
                    theme={{
                        disableThemeScrollbar: true,
                    }}
                    config={config}
                    style={candidateCv?.split('.')?.pop() === 'docx' ? {
                        transform: window.innerWidth <= 1024 ? `scale(${isFullCv ? 0.8 : 0.5})` : 'none', // Apply zoom out on small and medium screens
                        transformOrigin: window.innerWidth <= 1024 ? 'top left' : 'initial', // Set origin for scaling on small and medium screens
                        width: window.innerWidth <= 1024 ? (isFullCv ? "125%" : "200%") : '100%', // Adjust width for scaling on small and medium screens
                        height: window.innerWidth <= 1024 ? '100vh' : '150vh', // Adjust height for scaling on small and medium screens
                    } : {}}
                />
            ) : (
                <Warning title="Something went wrong" message="Failed loading documents, please refresh" />
            )}
        </>
    )
}